import PopularArticleMobile from './popular_article_mobile'
import PopularArticleDesktop from './popular_article_desktop'

const PopularArticle = ({ is_mobile, dataPopular }) => {
  const props = {
    is_mobile: is_mobile || false,
    dataPopular: Array.isArray(dataPopular) ? dataPopular : [],
  }

  if (props.is_mobile) {
    return <PopularArticleMobile {...props} />
  } else {
    return <PopularArticleDesktop {...props} />
  }
}

export default PopularArticle
